import plTranslations from './resources/pl_PL.json';
import { translationsInit } from './translationsInit';

// disabled because plTranslations is imported file (not present in the repository)
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
export default translationsInit({ pl: { translation: plTranslations } });
